//live
var toolbarIntMessages = null;
var gIntMsgs = null;
var gIntMsgsGroupBy = 'group_none';
var cIntMsgs = null;
var cIntMsgsSent = null;
var projectCustomFieldList = '';
var intMessagesCheckedRows = '';
var projectContactFields = [],
	lastProjectCustomField = null;

function IntSubject(sender) {
	var cell = jQuery(sender).parent();
	cell.trigger({
		type: 'mouseclick',
		button: 0
	}); //.trigger({type:'mouseup'});
	setTimeout(function () {
		ViewMessage(gIntMsgs.getSelectedRowId());
	}, 10);
	return false;
}

function SendIntMessageC(response) {
	InitializegIntMsgs(gIntMsgsGroupBy);
}

function ViewMessage(messageId) {
	PanteraScript.PanteraScriptService.GetInternalMessage(pjqSessionId, messageId, ViewMessageC, onScriptError);
}

function downloadMessageAttachment(entryId) {
	PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
		{
			endpoint: 'files',
			value: entryId
		},
		{
			endpoint: 'downloadentryid'
		}
	]), {
		isEndpoint: true,
		isApi2: true
	});
}

function ViewMessageC(response) {
	var msg = jQuery.parseJSON(response);
	jQuery('#intmessage-context-message').val(msg.MessageId);
	jQuery('#intmessage-context-pc').val(msg.ProjectContactId);
	jQuery('#intmessage-replytext').val('');
	jQuery('#intmessage-conversation').html('');

	var template = "<div class='conv-message'>";
	template += "<div class='conv-logo'><img src='{{>ProfileImage}}' /></div>";
	template += "<div class='conv-sender'><b>{{>Message.FromCompanyName}}</b><br />{{>Message.FromContactName}}<br /><span style='color: #ADADAD;'>said:</span></div>";
	template += "<div class='conv-files'>";
	template += "{{for Attachments}}";
	template += "<a href='javascript:void(0)' onclick='return downloadMessageAttachment({{>Id}})'><img class='pjq-icon' src='{{>Icon}}' /></a> <a href='javascript:void(0)' onclick='return pjqDL({{>Id}});' style='vertical-align: middle;'>{{>Name}}</a><br />";
	template += "{{/for}}";
	template += "</div>";
	//template += "<div class='conv-subject'>{{>Message.MessageSubject}}</div><br />";
	template += "<div class='conv-body'>{{>Message.MessageBody}}</div>";
	template += "<div class='ui-helper-clearfix'></div>";
	template += "</div>";
	var convTemplate = $.templates(template);
	var i = 0;
	for (i = 0; i < msg.Conversation.length; i++) {
		var sep = "<hr class='conv-hr' />";
		jQuery('#intmessage-conversation').append(convTemplate.render(msg.Conversation[i]) + sep);
	}

	var buttonList = {
		'Delete Message': function () {
			$(this).dialog("close");
			intMessagesCheckedRows = gIntMsgs.getSelectedRowId();
			HandleIntMsgDelete();
		}
	};

	ClearValidationError('#intmessage-replytext');
	jQuery('#intmessage-reply').removeClass('pjq-hidden');
	buttonList = {
		Reply: function () {
			ClearValidationError('#intmessage-replytext');

			if (jQuery('#intmessage-replytext').val().trim().length == 0) {
				SetValidationError('#intmessage-replytext', 'Message is Required.');
				return false;
			}

			PanteraScript.PanteraScriptService.SendInternalMessage(pjqSessionId, parseInt(jQuery('#intmessage-context-pc').val()), jQuery('#intmessage-replytext').val(), jQuery('#intmessage-context-message').val(), SendIntMessageC, onScriptError);

			$(this).dialog("close");
		},
		'Delete Message': function () {
			$(this).dialog("close");
			intMessagesCheckedRows = gIntMsgs.getSelectedRowId();
			HandleIntMsgDelete();
		}
	};

	var subject = 'View Message - ' + msg.MessageSubject + ' (' + msg.MessageType + ')';

	var dlg = jQuery("#dialog-intmessage").dialog({
		width: 600,
		modal: true,
		title: subject,
		buttons: buttonList
	});
	dlg.parent().appendTo($("Form[name='Form']"));

}

function PJQProjectWallAdminProjectHomeInitialize() {
	if (google && google.maps && google.mapsGeocoder) {
		geocoder = new google.maps.Geocoder();
		myLatLng = new google.maps.LatLng(42.8282, -98.5795);
		mapOptions = {
			zoom: 15,
			center: myLatLng,
			mapTypeId: google.maps.MapTypeId.SATELLITE
		}
	}

	if (settings.IsProjectPostalCodeRequired) {
		jQuery('#project-zip').addClass('required');
		jQuery('#project-location-required').addClass('pjq-label-required');
		jQuery('#project-location-required').html('*');
	}

	if (settings.IsProjectUser2Required) {
		jQuery('#project-user-2').addClass('required');
		jQuery('#project-user-2-required').addClass('pjq-label-required');
		jQuery('#project-user-2-required').html('*');
	}

	jQuery('td.pjq-project-response-due-label').html(settings.ProjectResponseDueLabel);
	jQuery('td.pjq-project-user-1-label').html(settings.ProjectUser1Label);
	jQuery('td.pjq-project-user-2-label').html(settings.ProjectUser2Label);
	jQuery('#project-notes-label').text(settings.ProjectNotesLabel);

	jQuery("div.pjq-project-custom-field tbody tr td input.pjq-money-field-width").inputmask("$999,999,999", {
		placeholder: " "
	});
	if (project.Country == 'CA')
		jQuery("#project-zip").mask('A9A 9A9', {
			placeholder: " "
		});
	else
		jQuery("#project-zip").mask('99999', {
			placeholder: " "
		});

	jQuery("input.pjq-date-field-width").mask('99/99/9999', {
		placeholder: " "
	});

	jQuery('input.pjq-date-field-width').datepicker({
		showOn: "button",
		numberOfMonths: 3,
		showButtonPanel: true,
		buttonImage: "/i/calendar.png",
		buttonImageOnly: true,
		onSelect: ValidateDateHelper
	});

	if (pjqIsNewProject && settings.DefaultBidDueTimeZone && settings.DefaultBidDueTimeZone.length > 0) {
		jQuery('#project-response-due-timezone').val(settings.DefaultBidDueTimeZone);
	}
	jQuery('#project-response-due-time').off('keydown');
	jQuery('#project-response-due-time').on('keydown', function (e) {
		return e.keyCode === 77 || e.keyCode === 80 || PJQ.helpers.inputHelpers.numbersOnly(e);
	});

	if (settings.IsNotesRequired) {
		jQuery('#pjq-notes-required').addClass('pjq-label-required').text('*');
		jQuery('#project-notes').addClass('required');
	}

	var i = 0;
	var optionList = '';
	var userOpts = Array();
	for (i = 0; i < settings.CompanyUsers.length; i++) {
		optionList = optionList + "<option value='" + settings.CompanyUsers[i].UserId.toString() + "'>" + settings.CompanyUsers[i].ContactName + "</option>";
	}
	jQuery('#project-user-1').append("<option value=''>Select...</option>" + optionList);
	if (jQuery('#project-user-1').find('option[value="' + project.UserId.toString() + '"]').length > 0)
		jQuery('#project-user-1').val(project.UserId.toString());
	else if (project.ProjectId > 0) {
		jQuery('#project-user-1').trigger('change');
		ProjectSave();
	}
	jQuery('#project-user-2').append("<option value=''>Select...</option>" + optionList);
	if (project.User2Id) {
		if (jQuery('#project-user-2').find('option[value="' + project.User2Id.toString() + '"]').length > 0)
			jQuery('#project-user-2').val(project.User2Id.toString());
		else {
			jQuery('#project-user-2').trigger('change');
			ProjectSave();
		}
	}

	for (i = 0; i < settings.InternalMessageUsers.length; i++) {
		userOpts.push(Array('user_' + settings.InternalMessageUsers[i].UserID.toString(), 'obj', settings.InternalMessageUsers[i].DisplayName + " (" + settings.InternalMessageUsers[i].MessageCount.toString() + ")", ''));
	}

	toolbarIntMessages = new dhtmlXToolbarObject("grid-toolbar-home");
	toolbarIntMessages.setSkin("dhx_web");
	toolbarIntMessages.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	var inboxOpts = Array(Array('view_inbox', 'obj', 'Inbox', ''), Array('view_sent', 'obj', 'Sent Messages', ''));
	var groupOpts = Array(Array('group_none', 'obj', 'no Grouping', ''), Array('group_company', 'obj', 'by Company', ''), Array('group_category', 'obj', 'by Category', ''));
	toolbarIntMessages.addButtonSelect("view", 1, "Inbox", inboxOpts, "database.gif", "");
	toolbarIntMessages.addSeparator("sep1", 2);
	toolbarIntMessages.addButtonSelect("user", 3, "User", userOpts, "worker.png", "workerD.png");
	toolbarIntMessages.setListOptionSelected("user", "user_" + settings.UserId.toString());
	toolbarIntMessages.addSeparator("sep1", 4);
	toolbarIntMessages.addButton("refresh", 5, "", "refresh.gif", "refresh.gif");
	toolbarIntMessages.addSeparator("sep3", 6);
	toolbarIntMessages.addButtonSelect("group", 8, "Group", groupOpts, "group.gif", "");
	toolbarIntMessages.addSeparator("sep5", 9);
	toolbarIntMessages.addButton("mark_read", 12, "Mark Read", "msg_read.gif", "msg_readD.gif");
	toolbarIntMessages.disableItem("mark_read");
	toolbarIntMessages.addSeparator("sep7", 13);
	toolbarIntMessages.addButton("mark_unread", 14, "Mark Unread", "msg_unread.gif", "msg_unreadD.gif");
	toolbarIntMessages.disableItem("mark_unread");
	toolbarIntMessages.addSeparator("sep8", 15);
	toolbarIntMessages.addButton("delete", 16, "", "action_delete.gif", "action_deleteD.gif");
	toolbarIntMessages.disableItem("delete");
	toolbarIntMessages.attachEvent("onClick", function (id) {
		if (id == 'group_company')
			InitializegIntMsgs(id);
		else if (id == 'group_category')
			InitializegIntMsgs(id);
		else if (id == 'group_none')
			InitializegIntMsgs(id);
		else if (id == 'view_inbox' || id == 'view_sent' || (id.length > 5 && id.substring(0, 5) == 'user_')) {
			if (id == 'view_inbox')
				toolbarIntMessages.setItemText("view", "Inbox");
			else if (id == 'view_sent')
				toolbarIntMessages.setItemText("view", "Sent Items");

			InitializegIntMsgs(gIntMsgsGroupBy);
		}
		else if (id == 'refresh') {
			InitializegIntMsgs(gIntMsgsGroupBy);
		}
		else if (id == 'mark_read') {
			intMessagesCheckedRows = gIntMsgs.getCheckedRows(0);
			HandleIntMsgRead();
		}
		else if (id == 'mark_unread') {
			intMessagesCheckedRows = gIntMsgs.getCheckedRows(0);
			HandleIntMsgUnread();
		}
		else if (id == 'delete') {
			intMessagesCheckedRows = gIntMsgs.getCheckedRows(0);
			HandleIntMsgDelete();

		}

	});

	cIntMsgs = new dhtmlXMenuObject();
	cIntMsgs.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
	cIntMsgs.addNewChild(cIntMsgs.topId, 0, "open_item", "Open Item", false, "ico_ticketproperties.gif");
	cIntMsgs.addNewChild(cIntMsgs.topId, 1, "view_contact", "Contact Details", false, "ico_contact.gif");
	cIntMsgs.addNewChild(cIntMsgs.topId, 3, "mark_read", "Mark Read", false, "msg_read.gif");
	cIntMsgs.addNewChild(cIntMsgs.topId, 4, "mark_unread", "Mark Unread", false, "msg_unread.gif");
	cIntMsgs.addNewChild(cIntMsgs.topId, 5, "delete", "Delete", false, "action_delete.gif");
	cIntMsgs.renderAsContextMenu();
	cIntMsgs.attachEvent("onClick", function (id, zoneId, casState) {
		if (id == 'view_contact') {
			var pc = gIntMsgs.getUserData(gIntMsgs.getSelectedRowId(), "FromProjectContactId");
			subgridCheckedRows = pc;
			EditContact('pc', pc);
		}
		else if (id == 'mark_read') {
			intMessagesCheckedRows = gIntMsgs.getSelectedRowId();
			HandleIntMsgRead();
		}
		else if (id == 'mark_unread') {
			intMessagesCheckedRows = gIntMsgs.getSelectedRowId();
			HandleIntMsgUnread();
		}
		else if (id == 'delete') {
			intMessagesCheckedRows = gIntMsgs.getSelectedRowId();
			HandleIntMsgDelete();
		}
		else if (id == 'open_item') {
			ViewMessage(gIntMsgs.getSelectedRowId());
		}
	});

	cIntMsgsSent = new dhtmlXMenuObject();
	cIntMsgsSent.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
	cIntMsgsSent.addNewChild(cIntMsgsSent.topId, 0, "open_item", "Open Item", false, "ico_ticketproperties.gif");
	cIntMsgsSent.addNewChild(cIntMsgsSent.topId, 1, "view_contact", "Contact Details", false, "ico_contact.gif");
	cIntMsgsSent.addNewChild(cIntMsgsSent.topId, 5, "delete", "Delete", false, "action_delete.gif");
	cIntMsgsSent.renderAsContextMenu();
	cIntMsgsSent.attachEvent("onClick", function (id, zoneId, casState) {
		if (id == 'view_contact') {
			var pc = gIntMsgs.getUserData(gIntMsgs.getSelectedRowId(), "ToProjectContactId");
			subgridCheckedRows = pc;
			EditContact('pc', pc);
		}
		else if (id == 'delete') {
			intMessagesCheckedRows = gIntMsgs.getSelectedRowId();
			HandleIntMsgDelete();
		}
		else if (id == 'open_item') {
			ViewMessage(gIntMsgs.getSelectedRowId());
		}
	});

	gIntMsgsGroupBy = 'group_none';
	InitializegIntMsgs(gIntMsgsGroupBy);
}

function HandleIntMsgUnread() {
	var parts = intMessagesCheckedRows.split(",");
	var i = 0;
	for (i = 0; i < parts.length; i++) {
		gIntMsgs.setUserData(parts[i], "ViewedOn", "");
		gIntMsgs.setRowTextBold(parts[i]);
	}
	PanteraScript.PanteraScriptService.UpdateInternalMessageViewedOn(pjqSessionId, intMessagesCheckedRows, false, null, onScriptError);
}

function HandleIntMsgRead() {
	var parts = intMessagesCheckedRows.split(",");
	var i = 0;
	for (i = 0; i < parts.length; i++) {
		gIntMsgs.setUserData(parts[i], "ViewedOn", "true");
		gIntMsgs.setRowTextNormal(parts[i]);
	}
	PanteraScript.PanteraScriptService.UpdateInternalMessageViewedOn(pjqSessionId, intMessagesCheckedRows, true, null, onScriptError);
}

function HandleIntMsgDelete() {
	var messageCount = intMessagesCheckedRows.split(',').length;
	var message = 'message';
	if (messageCount > 1)
		message = 'messages';
	showInfoDialogPWall('Delete Confirmation', 'Are you sure you want to permanently delete ' + messageCount.toString() + ' ' + message + '?', 'ui-icon-alert', 'delete-intmessages');
}

var intMsgFirstLoad = true;

function InitializegIntMsgs(groupBy) {
	gIntMsgsGroupBy = groupBy;
	gIntMsgs = new dhtmlXGridObject('grid-home');
	gIntMsgs.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
	gIntMsgs.enableMultiline(true);
	gIntMsgs.setSkin(pjqGridTheme);

	if (groupBy == 'group_none') {
		jQuery('#grid-paging-home').removeClass('pjq-hidden');
		gIntMsgs.enablePaging(true, 10, 3, "grid-paging-home");
		gIntMsgs.setPagingSkin("toolbar", 'dhx_web');
	}
	else
		jQuery('#grid-paging-home').addClass('pjq-hidden');

	jQuery('#grid-home').css('width', '99%');
	gIntMsgs.init();
	dhtmlxEvent(window, "resize", function () {
		jQuery('#grid-home').css('width', '99%');
		gIntMsgs.setSizes();
	});
	gIntMsgs.enableAutoHeight(true);

	gIntMsgs.attachEvent("onRowCreated", function (rId, rObj, rXml) {
		var viewedOn = gIntMsgs.getUserData(rId, "ViewedOn");
		if (viewedOn.length == 0)
			gIntMsgs.setRowTextBold(rId);
	});

	gIntMsgs.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		obj.selectRowById(id);
		return true;
	});

	gIntMsgs.attachEvent("onCheck", function (rId, cInd, state) {
		IntMessageToolbarRefresh(state);
	});

	var userId = settings.InternalMessageUserIdDefault.toString();
	if (!intMsgFirstLoad) {
		userId = toolbarIntMessages.getListOptionSelected("user");
		if (userId && userId.indexOf('_') != -1)
			userId = userId.substring(userId.indexOf('_') + 1);
		else
			userId = settings.InternalMessageUserIdDefault.toString();
	}

	intMsgFirstLoad = false;

	var view = 'inbox';
	if (toolbarIntMessages.getListOptionSelected("view") == 'view_sent') {
		view = 'sent';
		gIntMsgs.enableContextMenu(cIntMsgsSent);
	}
	else
		gIntMsgs.enableContextMenu(cIntMsgs);


	gIntMsgs.attachEvent("onBeforeSorting", function (ind, type, direction) {
		if (ind == 2 || ind == 3) {
			this.sortRows(ind, 'grid_sort_intmsgs', direction); // sort grid by the column with prepared values
			this.setSortImgState(true, ind, direction); // set a correct sorting image
			return false; // block default sorting
		}
		return true;
	});

	if(project.ProjectId > 0){
		gIntMsgs.loadXML('https://api.tm.panteratools.com/projects/' + project.ProjectId + '/internalmessages/' + userId.toString() + '/' + view + '?sessionid=' + pjqSessionId, function () {
			if (gIntMsgsGroupBy == 'group_company') {
				gIntMsgs.groupBy(2);
				gIntMsgs.collapseAllGroups();
			}
			if (gIntMsgsGroupBy == 'group_category') {
				gIntMsgs.groupBy(4);
				gIntMsgs.collapseAllGroups();
			}

			var userOpts = Array();
			var userDataTemp = gIntMsgs.getUserData(null, "InternalMessageUsers");
			var userData = userDataTemp.split(',');
			var i = 0;
			for (i = 0; i < userData.length; i++) {
				var parts = userData[i].split('|');
				userOpts.push(Array('user_' + parts[0], 'obj', parts[1] + " (" + parts[2] + ")", ''));
			}
			toolbarIntMessages.removeItem("user");
			toolbarIntMessages.addButtonSelect("user", 2, "User", userOpts, "worker.png", "workerD.png");
			toolbarIntMessages.setListOptionSelected("user", "user_" + userId.toString());

			IntMessageToolbarRefresh();
		});
	}
}

function LVStoreNameChanged(sender) {
	var projectName = jQuery('#project-name').val().trim();
	if (projectName.length == 0) {
		jQuery('#project-name').val(jQuery('#' + jQuery(sender).attr('id') + ' option:selected').text());
		jQuery("div.projectheader-projectname").text(jQuery('#project-name').val());
		ClearValidationError('#project-name');
	}
}

function BiConCompanyChanged(sender) {
	var projectName = jQuery('#project-name').val().trim();
	if (projectName.length == 0) {
		jQuery('#project-name').val(jQuery('#' + jQuery(sender).attr('id') + ' option:selected').text());
		jQuery("div.projectheader-projectname").text(jQuery('#project-name').val());
		ClearValidationError('#project-name');
	}
}

var notesEditor = null;

function PJQProjectWallAdminProjectCustomFieldsInitialize() {
	jQuery('div.pjq-project-custom-field').remove();
	var i = 0;
	var template = '';
	for (i = 0; i < projectCustomFields.length; i++) {
		if (projectCustomFields[i].projectCustomFieldId == 576) {
			// render 'store name' select in a custom spot for LV
			var template2 = '';
			template2 += "          <select id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-choice-field-width selectREQ' data-choice-list='{{attr:fieldValue}}' onchange='EnableSaveP();LVStoreNameChanged(this);'>";
			template2 += "          <option value=''>Select...</option>";
			template2 += " {{for choiceList}}";
			template2 += "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}' {{if fieldValue && fieldValue.toString().indexOf(choiceName)>-1}}selected='selected'{{/if}}>{{>choiceName}}</option>";
			//template2 +=  "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}'>{{>choiceName}}</option>";
			template2 += " {{/for}}";
			template2 += "          </select>";
			var pcfTemplate = $.templates(template2);
			jQuery('#lv-store-name').html(pcfTemplate.render(projectCustomFields[i]));
		}
		else if (projectCustomFields[i].projectCustomFieldId == 59 | projectCustomFields[i].projectCustomFieldId == 77 | projectCustomFields[i].projectCustomFieldId == 425) {
			// render 'store name' select in a custom spot for LV
			var template2 = '';
			template2 += "          <select id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-choice-field-width{{if isRequired}} selectREQ{{/if}}' data-choice-list='{{attr:fieldValue}}' onchange='EnableSaveP();'>";
			template2 += "          <option value=''>Select...</option>";
			template2 += " {{for choiceList}}";
			template2 += "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}' {{if fieldValue && fieldValue.toString().indexOf(choiceName)>-1}}selected='selected'{{/if}}>{{>choiceName}}</option>";

			//template2 +=  "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}'>{{>choiceName}}</option>";
			template2 += " {{/for}}";
			template2 += "          </select>";
			var pcfTemplate = $.templates(template2);
			if (projectCustomFields[i].projectCustomFieldId == 59) {
				jQuery('#lv-project-estimator').html(pcfTemplate.render(projectCustomFields[i]));
			}
			else if (projectCustomFields[i].projectCustomFieldId == 77) {
				jQuery('#lv-project-pm').html(pcfTemplate.render(projectCustomFields[i]));
			}
			else if (projectCustomFields[i].projectCustomFieldId == 425) {
				jQuery('#lv-project-ec').html(pcfTemplate.render(projectCustomFields[i]));
			}
		}
		else if (projectCustomFields[i].projectCustomFieldId == 985) {
			// render 'PM Notes' field on separate tab
			//var template2 = '';
			//template2 += "         <textarea id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-textarea-field-width {{if isRequired}} required {{/if}}' onchange='EnableSaveP();' onkeydown='return EnableSaveP();'>{{attr:fieldValue}}</textarea>";
			//var pcfTemplate = $.templates(template2);
			//jQuery('#lv-pm-notes').html(pcfTemplate.render(projectCustomFields[i]));
			if (projectCustomFields[i].fieldValue && projectCustomFields[i].fieldValue.length > 0)
				lastEditorVal = projectCustomFields[i].fieldValue;
			else
				lastEditorVal = '';
			initProjectNotesEditor(projectCustomFields[i].fieldValue);
		}
		else if (projectCustomFields[i].projectCustomFieldId == 91) {
			// render 'due to client date' field in a custom spot for LV
			var template2 = '';
			template2 += "         <input id='project-custom-{{attr:projectCustomFieldId}}' type='text' class='pjq-date-field-width{{if isRequired}} date required{{else}} dateOPT{{/if}}' value='{{>~parseDate(fieldValue)}}' maxlength='10' onkeydown='return EnableSaveP();' onchange='lvdtc(this)' />";
			var pcfTemplate = $.templates(template2);
			jQuery('#lv-dtc-date').html(pcfTemplate.render(projectCustomFields[i]));
		}
		else if (projectCustomFields[i].projectCustomFieldId == 73) {
			var template2 = '';
			template2 += "       <input id='project-custom-{{attr:projectCustomFieldId}}' type='text' class='pjq-default-field-width{{if isRequired}} required{{/if}}' value='{{attr:fieldValue}}' maxlength='255' onchange='EnableSaveP();' onkeydown='return EnableSaveP();' />";
			var pcfTemplate = $.templates(template2);
			jQuery('#lv-store-number').html(pcfTemplate.render(projectCustomFields[i]));
		}
		else if (projectCustomFields[i].projectCustomFieldId == 92) {
			// do nothing, is added along with 93 below
		}
		else if (projectCustomFields[i].projectCustomFieldId == 93) {
			// render 'due to client time' field in a custom spot for LV
			var template2 = '';
			var template3 = '';
			var dtc = '';
			template2 += "          <select id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-choice-field-width{{if isRequired}} selectREQ{{/if}}' data-choice-list='{{attr:fieldValue}}' onchange='EnableSaveP();'>";
			template2 += "          <option value=''>Select...</option>";
			template2 += " {{for choiceList}}";
			template2 += "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}' {{if fieldValue && fieldValue.toString().indexOf(choiceName)>-1}}selected='selected'{{/if}}>{{>choiceName}}</option>";
			//template2 +=  "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}'>{{>choiceName}}</option>";
			template2 += " {{/for}}";
			template2 += "          </select>";
			template2 += "&nbsp;&nbsp;";
			var j;
			for (j = 0; j < projectCustomFields.length; j++) {
				if (projectCustomFields[j].projectCustomFieldId == 92) {
					template3 += "          <select id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-choice-field-width{{if isRequired}} selectREQ{{/if}}' data-choice-list='{{attr:fieldValue}}' onchange='EnableSaveP();'>";
					template3 += "          <option value=''>Select...</option>";
					template3 += " {{for choiceList}}";
					template3 += "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}' {{if fieldValue && fieldValue.toString().indexOf(choiceName)>-1}}selected='selected'{{/if}}>{{>choiceName}}</option>";
					//template3 +=  "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}'>{{>choiceName}}</option>";
					template3 += " {{/for}}";
					template3 += "          </select>";
					var pcfTemplate3 = $.templates(template3);
					dtc = pcfTemplate3.render(projectCustomFields[j]);
				}
			}
			var pcfTemplate = $.templates(template2);
			jQuery('#lv-dtc-time').html(pcfTemplate.render(projectCustomFields[i]) + dtc);

		}
		else if (projectCustomFields[i].projectCustomFieldId == 2577) {

			// render 'company' select in a custom spot for bi-con
			jQuery('tr.customer180200').show();

			var template2 = '';
			template2 += "          <select id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-choice-field-width selectREQ' data-choice-list='{{attr:fieldValue}}' onchange='EnableSaveP();BiConCompanyChanged(this);'>";
			template2 += "          <option value=''>Select...</option>";
			template2 += " {{for choiceList}}";
			template2 += "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}' {{if fieldValue && fieldValue.toString().indexOf(choiceName)>-1}}selected='selected'{{/if}}>{{>choiceName}}</option>";
			//template2 +=  "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}'>{{>choiceName}}</option>";
			template2 += " {{/for}}";
			template2 += "          </select>";
			var pcfTemplate = $.templates(template2);
			jQuery('#bi-con-company').html(pcfTemplate.render(projectCustomFields[i]));


		}
		else {
			template = '';
			template += "<div class='project-home-table-column pjq-project-custom-field' style='{{if fieldType =='INT'}}margin-bottom: 0px;{{/if}}'>";
			template += "  <table class='pjq-editable-table' >";
			template += "     <tr>";
			template += "       <td class='pjq-field-label project-home-table-label'>{{>fieldName}}</td>";
			template += "      {{if isRequired}}<td class='pjq-label-required' style='width: 8px;'>*</td>{{else}}<td style='width: 8px;'>&nbsp;</td>{{/if}}";
			template += "      <td class='pjq-field-value'>";

			template += "{{if fieldType == 'TEXT'}}";
			template += "       <input id='project-custom-{{attr:projectCustomFieldId}}' type='text' class='pjq-default-field-width{{if isRequired}} required{{/if}}' value='{{attr:fieldValue}}' maxlength='255' onchange='EnableSaveP();' onkeydown='return EnableSaveP();' />";
			template += "{{else fieldType == 'INT'}}";
			template += "         <input id='project-custom-{{attr:projectCustomFieldId}}' type='text' class='pjq-numeric-field-width integer{{if isRequired}} required{{/if}}' value='{{attr:fieldValue}}' maxlength='10'{{if numericMinValue > 0}} min='{{attr:numericMinValue}}'{{/if}}{{if numericMaxValue > 0}}  max='{{attr:numericMaxValue}}'{{/if}} onchange='EnableSaveP();' onkeydown='return EnableSaveP();' />";
			template += "{{else fieldType == 'DATE'}}";
			template += "         <input id='project-custom-{{attr:projectCustomFieldId}}' type='text' class='pjq-date-field-width{{if isRequired}} date required{{else}} dateOPT{{/if}}' value='{{>~parseDate(fieldValue)}}' maxlength='10' onkeydown='return EnableSaveP();' />";
			template += "{{else fieldType == 'DATETIME'}}";
			template += "         <input id='project-custom-{{attr:projectCustomFieldId}}' type='text' class='pjq-date-field-width{{if isRequired}} date required{{else}}{{/if}}' value='{{>~parseDateDT(fieldValue)}}' maxlength='10' onkeydown='return EnableSaveP();' />&nbsp;&nbsp;<input id='project-custom2-{{attr:projectCustomFieldId}}' type='text' class='pjq-time-field-width {{if isRequired}} time12h required{{else}} time12hOPT{{/if}}' value='{{>~parseTimeDT(fieldValue)}}' maxlength='8' onkeydown='return EnableSaveP();' /><img id='project-custom2-tp-{{attr:projectCustomFieldId}}' class='ui-timepicker-trigger' src='/i/icon_scheduler_16px.gif' alt='...' title='...'>";
			template += "{{else fieldType == 'MONEY'}}";
			template += "         <input id='project-custom-{{attr:projectCustomFieldId}}' type='text' class='pjq-money-field-width' value='{{attr:fieldValue}}' onchange='EnableSaveP();FormatCurrencyHelper(jQuery(this));' onkeydown='return EnableSaveP();' />";
			template += "{{else fieldType == 'MONEY'}}";
			template += "         <input id='project-custom-{{attr:projectCustomFieldId}}' type='text' class='pjq-money-field-width' value='{{attr:fieldValue}}' onchange='EnableSaveP();FormatCurrencyHelper(jQuery(this));' onkeydown='return EnableSaveP();' />";
			template += "{{else fieldType == 'TEXTAREA'}}";
			template += "         <textarea id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-textarea-field-width {{if isRequired}} required{{/if}}' onchange='EnableSaveP();' onkeydown='return EnableSaveP();' >{{attr:fieldValue}}</textarea>";
			template += "{{else fieldType == 'BOOL'}}";
			template += "         <select id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-bool-field-width{{if isRequired}} selectREQ{{/if}}' onchange='EnableSaveP();'>";
			template += "          <option value=''>Select Answer...</option>";
			template += "          <option value='true'{{if fieldValue == 'true' || fieldValue == 'Yes'}} selected='selected'{{/if}}>Yes</option>";
			template += "          <option value='false'{{if fieldValue == 'false' || fieldValue == 'No'}} selected='selected'{{/if}}>No</option>";
			template += "         </select>";
			template += "{{else fieldType == 'CHOICE'}}";
			template += " {{if isChoiceListMultipleChoice}}";
			template += "          <div id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-choice-field-width pjq-multiple-choice-list {{if isRequired}} pjq-required{{/if}}'  data-choice-list='{{attr:fieldValue}}'>";
			template += " {{for choiceList ~projectCustomFieldId=projectCustomFieldId}}";
			template += "          <input type='checkbox' id='project-custom-{{>~projectCustomFieldId}}_{{attr:choiceId}}' value='{{attr:choiceId}}' choice-name='{{attr:choiceName}}' onchange='EnableSaveP();' />";
			template += "           <label for='myCustom_{{attr:projectCustomFieldId}}_{{attr:choiceId}}'>{{>choiceName}}</label><br />";
			template += " {{/for}}";
			template += "         </div>";
			template += " {{else}}";
			template += "          <select id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-choice-field-width{{if isRequired}} selectREQ{{/if}}' data-choice-list='{{attr:fieldValue}}' onchange='EnableSaveP();'>";
			template += "          <option value=''>Select...</option>";
			template += " {{for choiceList}}";
			template += "           <option value='{{attr:choiceId}}' text='{{attr:choiceName}}' {{if fieldValue && fieldValue.toString().indexOf(choiceName)>-1}}selected='selected'{{/if}}>{{>choiceName}}</option>";
			template += " {{/for}}";
			template += "          </select>";
			template += " {{/if}}";
			template += "{{else fieldType == 'CONTACT'}}";

			template += "  <div id='project-custom-{{attr:projectCustomFieldId}}' class='pjq-contact-field-width{{if isRequired}} selectREQ{{/if}}{{if isChoiceListMultipleChoice}} pjq-multiple-contact-list{{/if}}' style='width:100%;'><div id='pjq-contact-tb-{{attr:projectCustomFieldId}}' class='pjq-contact-toolbar'></div><div id='pjq-contact-grid-{{attr:projectCustomFieldId}}' class='pjq-contact-grid' style='width:100%;'></div></div>";
			template += "{{/if}}";

			template += "      </td></tr>";
			template += "  </table>";
			template += "</div>";
			var pcfTemplate = $.templates(template);

			jQuery('#project-custom-fields-loading').before(pcfTemplate.render(projectCustomFields[i]));
		}
	}
	jQuery('#project-custom-fields-loading').text('');
	jQuery('#project-notes-custom-field-loading').addClass('pjq-hidden');
	jQuery('.miscNotesTable').removeClass('pjq-hidden');

	jQuery("div.pjq-contact-field-width", jQuery('div.pjq-project-custom-field')).each(function () {
		var id = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('-') + 1);
		var tbDiv = jQuery('div.pjq-contact-toolbar', jQuery(this));
		var tbContact = new dhtmlXToolbarObject(tbDiv.attr('id'));
		tbContact.setSkin("dhx_web");
		tbContact.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
		tbContact.addButton("add", 1, "Add", "addcontact.png", "addcontactD.png");
		tbContact.disableItem("add");
		tbContact.addSeparator("sep1", 2);
		tbContact.addButton("edit", 3, "Details", "worker.png", "workerD.png");
		tbContact.disableItem("edit");
		tbContact.addSeparator("sep2", 4);
		//tbContact.addSpacer("sep2");
		//tbContact.addSeparator("sep3", 5);
		tbContact.addButton("delete", 6, "Delete", "action_delete.gif", "action_deleteD.gif");
		tbContact.disableItem("delete");
		tbContact.attachEvent("onClick", function (id) {
			lastProjectCustomField = jQuery(this.cont).attr('id');
			lastProjectCustomField = lastProjectCustomField.substring(lastProjectCustomField.lastIndexOf('-') + 1);
			if (id == 'add') {
				if (!jQuery('#project-save').button('option', 'disabled')) {
					if (!SaveProject())
						return;
				}

				setTimeout(function () {
					var url = '/Default.aspx?tabId=' + settings.AddressBookTabId.toString() + '&pcf=' + pjqSessionId + '&pcfid=' + lastProjectCustomField;
					window.location.href = url;
				}, 500);
			}
			else if (id == 'edit') {
				EditContactPCF();
			}
			else if (id == 'delete') {
				showInfoDialogPWall('Delete Contact', 'Are you sure you want to delete this Contact from the Project?', 'ui-icon-alert', 'delete-contacts-pcf');
			}
		});
		if (project.ProjectId == 0) {
			tbContact.disableItem('add');
		}
		var cmContact = new dhtmlXMenuObject();
		cmContact.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxMenu/imgs/");
		cmContact.addNewChild(cmContact.topId, 0, "edit", "Contact Details", false, "worker.png");
		cmContact.addNewChild(cmContact.topId, 1, "delete", "Delete Contact", false, "action_delete.gif");
		cmContact.setUserData("edit", "ProjectCustomFieldId", id);
		cmContact.setUserData("delete", "ProjectCustomFieldId", id);
		cmContact.renderAsContextMenu();
		cmContact.attachEvent("onClick", function (id, zoneId, casState) {
			lastProjectCustomField = cmContact.getUserData("edit", "ProjectCustomFieldId");
			if (id == 'edit') {
				EditContactPCF();
			}
			else if (id == 'delete') {
				showInfoDialogPWall('Delete Contact', 'Are you sure you want to delete this Contact from the Project?', 'ui-icon-alert', 'delete-contacts-pcf');
			}
		});


		var gDiv = jQuery('div.pjq-contact-grid', jQuery(this));
		var gridContact = new dhtmlXGridObject(gDiv.attr('id'));
		gridContact.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/'); //path to images required by grid
		gridContact.enableMultiline(true);
		gridContact.setSkin(pjqGridTheme);
		gridContact.setNoHeader(true);
		gDiv.css('width', '99%');
		gridContact.init();
		dhtmlxEvent(window, "resize", function () {
			gDiv.css('width', '99%');
			gridContact.setSizes();
		});
		gridContact.enableAutoHeight(true);

		if (!settings.IsProjectHomeReadonly)
			gridContact.enableContextMenu(cmContact);
		gridContact.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
			obj.selectRowById(id);
			return true;
		});

		gridContact.attachEvent("onRowSelect", function (rId) {
			this.setSelectedRow(rId);
			var id = gDiv.attr('id').substring(gDiv.attr('id').lastIndexOf('-') + 1);
			var i = 0;
			for (i = 0; i < projectContactFields.length; i++) {
				if (projectContactFields[i][0] == id) {
					var tb = projectContactFields[i][1];

					if (!settings.IsProjectHomeReadonly) {
						tb.enableItem("edit");
						tb.enableItem("delete");
					}
				}
			}

			return true;
		});

		projectContactFields.push([id, tbContact, gridContact, cmContact]);

		gridContact.loadXML('/DesktopModules/PJQProjectWallAdmin/GetPCFContacts.aspx?id=' + id + '&sessionid=' + pjqSessionId + '&x=' + (new Date).getTime(), function () {
			var id = gDiv.attr('id').substring(gDiv.attr('id').lastIndexOf('-') + 1);
			var i = 0;
			for (i = 0; i < projectContactFields.length; i++) {
				if (projectContactFields[i][0] == id) {
					var grid = projectContactFields[i][2];
					var tb = projectContactFields[i][1];
					if (grid.getRowsNum() == 0) {
						var msg = 'No Contact Selected';
						if (pjqIsNewProject)
							msg += ' - Save Project before adding a Contact';

						gDiv.prepend("<div style='padding: 4px; background-color: white;'>" + msg.replace('"', '') + "</div>");
						gDiv.css('height', '24px');

						if (project.ProjectId > 0 && !settings.IsProjectHomeReadonly)
							tb.enableItem("add");
					}
					else {
						if (gDiv.parent().hasClass('pjq-multiple-contact-list') && project.ProjectId > 0 && !settings.IsProjectHomeReadonly)
							tb.enableItem("add");
					}
				}
			}
		});

	});

	jQuery("input.pjq-date-field-width").each(function () {
		if (!jQuery(this).hasClass('hasDatepicker')) {
			jQuery(this).mask('99/99/9999', {
				placeholder: " "
			});
			jQuery(this).datepicker({
				showOn: "button",
				numberOfMonths: 3,
				showButtonPanel: true,
				buttonImage: "/i/calendar.png",
				buttonImageOnly: true,
				onSelect: ValidateDateHelper
			});
		}
	});

	jQuery("input.pjq-time-field-width").each(function () {
		if (!jQuery(this).hasClass('hasTimepicker')) {
			jQuery(this).timepicker({
				showOn: 'button',
				showPeriod: true,
				button: jQuery(this).siblings('.ui-timepicker-trigger'),
				onSelect: ValidateTimeHelper
			});
		}
	});

	jQuery("input.pjq-numeric-field-width").each(function () {
		var minVal = 0;
		if (jQuery(this).attr('min'))
			minVal = parseInt(jQuery(this).attr('min'));
		var maxVal = 2147483647;
		if (jQuery(this).attr('max'))
			maxVal = parseInt(jQuery(this).attr('max'));
		jQuery(this).spinner({
			min: minVal,
			max: maxVal,
			step: 1,
			spin: function (event, ui) {
				EnableSaveP();
			}
		});
	});


	jQuery("select.pjq-choice-field-width").each(function () {
		var x = jQuery(this).attr('data-choice-list').split('|||');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			//jQuery(this).find("option[value='"+x[i].trim()+"'], option[text='"+x[i].trim()+"']").attr('selected','selected');         
			jQuery(this).find("option[value='" + x[i].trim() + "'], option[text='" + x[i].trim() + "']").prop('selected', true);
			//jQuery(this).find("option[text='"+x[i].trim()+"']").attr('selected','selected'); 
			jQuery(this).find("option[text='" + x[i].trim() + "']").prop('selected', true);
		}
	});

	jQuery("div.pjq-multiple-choice-list").each(function () {
		var x = jQuery(this).attr('data-choice-list').split('|||');
		var i = 0;
		for (i = 0; i < x.length; i++) {
			//jQuery(this).find("input[choice-name='"+x[i].trim()+"']").attr('checked','checked'); 
			jQuery(this).find("input[choice-name='" + x[i].trim() + "']").prop('checked', true);
		}
	});
	jQuery("div.pjq-project-custom-field tbody tr td input.pjq-money-field-width").each(function () {

		FormatCurrencyHelper(jQuery(this));
	});

	if (project.ProjectId == 0) {
		//jQuery('#project-response-due-time').val('05:00 PM');
		jQuery('#project-custom-93').val('76');
		var dtNow = new Date();
		jQuery('#project-custom-74').val(jQuery.datepicker.formatDate('mm/dd/yy', dtNow));
		if (project.ResponseDueTimeZone)
			jQuery('#project-response-due-timezone').val(project.ResponseDueTimeZone);
		else
			jQuery('#project-response-due-timezone').val("Central");
	}
}


function ProjectResponseDueASAP() {
	if (jQuery('#project-response-due-asap').prop('checked')) {
		jQuery('#project-response-due,#project-response-due-time,#project-response-due-timezone').val('');
		jQuery('#project-response-due,#project-response-due-time,#project-response-due-timezone').attr("disabled", true);
		jQuery("#project-response-due").datepicker("option", "disabled", true);
		jQuery('div.projectheader-biddue').html(settings.ProjectResponseDueLabel + ':&nbsp;ASAP');
		EnableSaveP();
	}
	else {
		jQuery('#project-response-due-time').val('05:00 PM');
		jQuery('#project-response-due').removeAttr("disabled");
		jQuery('#project-response-due-time').removeAttr("disabled");
		jQuery('#project-response-due-timezone').removeAttr("disabled");
		jQuery("#project-response-due").datepicker("option", "disabled", false);
		ProjectResponseDueChanged();
	}
}


function projectCountryChanged() {
	if (jQuery('#project-country').val() == 'CA') {
		jQuery('#project-state-us').addClass('pjq-hidden');
		jQuery('#project-state-ca').removeClass('pjq-hidden');
		jQuery('#project-state-ca').val('');
		jQuery('#project-state-us').val('');
		jQuery('#project-zip').val('');
		jQuery('#project-zip').mask("A9A-9A9");
		jQuery('#project-zip').removeClass('zipcodeUS');
		jQuery('#project-zip').addClass('zipcodeCA');
		jQuery('#project-state-ca').focus();
	}
	else {
		jQuery('#project-state-ca').addClass('pjq-hidden');
		jQuery('#project-state-us').removeClass('pjq-hidden');
		jQuery('#project-state-us').val('');
		jQuery('#project-state-ca').val('');
		jQuery('#project-state-us').focus();
		jQuery('#project-zip').val('');
		jQuery('#project-zip').mask("99999");
		jQuery('#project-zip').addClass('zipcodeUS');
		jQuery('#project-zip').removeClass('zipcodeCA');
	}
	ProjectLocationChanged();

}

function SaveProject() {
	// validate all fields
	var errElem = null;

	// validate project core fields
	if (!validator.element('#project-name'))
		errElem = jQuery('#project-name');

	if (!validator.element('#project-address1'))
		errElem = jQuery('#project-address1');

	if (!validator.element('#project-address2'))
		errElem = jQuery('#project-address2');

	if (!validator.element('#project-city'))
		errElem = jQuery('#project-city');

	if (!validator.element('#project-zip'))
		errElem = jQuery('#project-zip');

	if (!validator.element('#project-response-due'))
		errElem = jQuery('#project-response-due');

	if (!validator.element('#project-user-1'))
		errElem = jQuery('#project-user-1');

	if (settings.IsProjectUser2Required) {
		if (!validator.element('#project-user-2'))
			errElem = jQuery('#project-user-2');
	}

	// validate project custom fields
	jQuery("#tabHome [id*=project-custom-]:not(#project-custom-fields-loading):not([type=checkbox])").each(function () {
		var hasError = false;
		if (jQuery(this).prop("id") == 'project-custom-1395') {
			jQuery('#project-custom-1395').val(jQuery('#project-custom-1395').val().trim());
			if (CountDigits(jQuery('#project-custom-1395').val()) != 10) {
				hasError = true;
				jQuery(this).parent().append("<label for='" + jQuery(this).prop('id') + "' class='pjq-errortext'>Please enter a 10-digit number.</label>");
				jQuery(this).addClass('pjq-errortext');
				errElem = jQuery(this);
			}
			else {
				jQuery(this).removeClass('pjq-errortext');
				jQuery(this).parent().find('label.pjq-errortext').remove();
			}

		}
		else if (jQuery(this).prop("tagName") == 'DIV') {
			if (jQuery(this).hasClass('pjq-required')) {
				if (jQuery("input[type='checkbox']:checked", this).length == 0) {
					hasError = true;
					jQuery(this).parent().append("<label for='" + jQuery(this).prop('id') + "' class='pjq-errortext'>Please check at least one selection.</label>");
					jQuery(this).addClass('pjq-errortext');
					errElem = jQuery(this);
				}
				else {
					jQuery(this).removeClass('pjq-errortext');
					jQuery(this).parent().find('label.pjq-errortext').remove();
				}
			}
		}
		else if (jQuery(this).prop("id").startsWith('project-custom2') && jQuery(this).val().length > 0) {
			// this is a datetime time field.   if it is non blank, then date field must be valid.
			// build id of base field
			// check field length
			var dateId = jQuery(this).prop("id").replace('custom2', 'custom');
			if (jQuery('#' + dateId).val().length == 0) {
				hasError = true;
				jQuery('#' + dateId).parent().append("<label for='" + jQuery(this).prop('id') + "' class='pjq-errortext'>Please enter a date.</label>");
				jQuery('#' + dateId).addClass('pjq-errortext');
				errElem = jQuery('#' + dateId);
			}
			else {
				jQuery('#' + dateId).removeClass('pjq-errortext');
				jQuery('#' + dateId).parent().find('label.pjq-errortext').remove();
			}
		}
		else if (!validator.element(this)) {
			errElem = jQuery(this);
		}
	});

	// if there's an error, set focus to the first bad field
	if (null != errElem) {
		// if we aren't on Project Home tab, select it.
		jQuery('#tabsMain').tabs('option', 'active', 0);
		errElem.focus();
		return false;
	}


	// save project core fields
	// save project custom fields
	var responseDue = jQuery('#project-response-due').val();
	if (jQuery('#project-response-due-asap').prop('checked'))
		responseDue = 'ASAP';

	var stateProvince = jQuery('#project-state-us').val();
	if (!stateProvince)
		stateProvince = jQuery('#project-state-ca').val();

	projectCustomFieldList = '';
	jQuery("#tabHome [id*=project-custom-]:not(#project-custom-fields-loading):not([type=checkbox])").each(function () {
		if (jQuery(this).attr('class') && (jQuery(this).attr('class').indexOf('dhxtoolbar') > -1 || jQuery(this).attr('class').indexOf('dhx_toolbar') > -1))
			return;

		if (jQuery(this).attr('class') && jQuery(this).attr('class').indexOf('pjq-contact-grid') > -1)
			return;

		if (!jQuery(this).attr('id'))
			return;


		var fieldId = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('-') + 1);

		if (jQuery(this).hasClass('pjq-contact-field-width')) {
			var id = jQuery(this).attr('id').substring(jQuery(this).attr('id').lastIndexOf('-') + 1);
			var i = 0;
			for (i = 0; i < projectContactFields.length; i++) {
				if (projectContactFields[i][0] == id) {
					var grid = projectContactFields[i][2];
					projectCustomFieldList = projectCustomFieldList + fieldId + '{|}' + grid.getAllRowIds() + '||||';
				}
			}
		}
		else if (jQuery(this).prop('tagName') == 'SELECT') {
			projectCustomFieldList = projectCustomFieldList + fieldId + '{|}';
			jQuery('option:selected', jQuery(this)).each(function () {
				projectCustomFieldList = projectCustomFieldList + jQuery(this).val() + ',';
			});
			if (projectCustomFieldList.substring(projectCustomFieldList.length - 1) == ',')
				projectCustomFieldList = projectCustomFieldList.substring(0, projectCustomFieldList.length - 1);
			projectCustomFieldList = projectCustomFieldList + '||||';
		}
		else if (jQuery(this).hasClass('pjq-money-field-width')) {
			var money = jQuery(this).val();
			projectCustomFieldList = projectCustomFieldList + fieldId + '{|}' + money + '||||';
		}
		else if (jQuery(this).hasClass('pjq-textarea-field-width')) {
			var textarea = jQuery(this).val();
			projectCustomFieldList = projectCustomFieldList + fieldId + '{|}' + textarea + '||||';
		}
		else if (jQuery(this).prop("tagName") == 'DIV') {
			projectCustomFieldList = projectCustomFieldList + fieldId + '{|}';
			jQuery("input[type='checkbox']:checked", this).each(function () {
				projectCustomFieldList = projectCustomFieldList + jQuery(this).val() + ',';
			});
			if (projectCustomFieldList.substring(projectCustomFieldList.length - 1) == ',')
				projectCustomFieldList = projectCustomFieldList.substring(0, projectCustomFieldList.length - 1);
			projectCustomFieldList = projectCustomFieldList + '||||';
		}
		else if (jQuery(this).hasClass('pjq-date-field-width') && jQuery(this).siblings('.pjq-time-field-width').length > 0) {
			projectCustomFieldList = projectCustomFieldList + fieldId + '{|}' + jQuery(this).val() + ' ' + jQuery(this).siblings('.pjq-time-field-width').val() + '||||';
		}
		else if (jQuery(this).hasClass('pjq-time-field-width')) {
			projectCustomFieldList = projectCustomFieldList + fieldId + '{|}' + jQuery(this).siblings('.pjq-date-field-width').val() + ' ' + jQuery(this).val() + '||||';
		}
		else {
			projectCustomFieldList = projectCustomFieldList + fieldId + '{|}' + jQuery(this).val() + '||||';
		}
	});
	if (projectCustomFieldList.length > 0)
		projectCustomFieldList = projectCustomFieldList.substring(0, projectCustomFieldList.length - 4);

	var userId = parseInt(jQuery('#project-user-1').val());
	var user2Id = 0;
	if (jQuery('#project-user-2').val())
		user2Id = parseInt(jQuery('#project-user-2').val());

	if (notesEditor != null) {
		projectCustomFieldList = projectCustomFieldList + '||||985{|}' + cleanWordPaste(notesEditor.getContent());
	}
	PanteraScript.PanteraScriptService.UpdateProjectAdmin(pjqSessionId, jQuery('#project-name').val(), jQuery('#project-address1').val(), jQuery('#project-address2').val(), jQuery('#project-city').val(), stateProvince, jQuery('#project-zip').val(), jQuery('#project-country').val(), jQuery('#project-notes').val(), responseDue, jQuery('#project-response-due-time').val(), jQuery('#project-response-due-timezone').val(), projectCustomFieldList, userId, user2Id, '', UpdateProjectC, onScriptError);

	return true;
}

function UpdateProjectC(response) {
	if (typeof PJQ != 'undefined') {
		if (PJQ.app.session.project != null) {
			PJQ.app.session.project.set('projectId', project.ProjectId);
			PJQ.app.session.project.fetch();
		}
	}

	if (pjqIsNewProject) {

		if (window.location.href.indexOf('#projects') === -1) {
			var url = window.location.href.replace('projectid=0', 'projectid=' + response);
			url += '&nps=1';
			window.location.href = url;
		}
		else {
			pjqProjectId = response;
			pjqWallContext = 'project';
			pjqIsNewProject = false;
			PJQ.app.router.navigate('projects/' + response, {
				trigger: true,
				replace: true
			});
		}
	}
	else {
		DisableSave();
		showLeftSideInfo('Project saved.');
	}
}

function ValidateDateHelper(name, sender) {
	var id = jQuery(sender).attr('id');

	ClearValidationError('#' + id);

	if (!ValidateDate(jQuery('#' + id).val()))
		SetValidationError('#' + id, 'Please enter a valid date.');

	if (id.startsWith('project-response') || id.startsWith('project-custom'))
		ProjectResponseDueChanged();

	if (id == 'project-custom-91')
		lvdtc(jQuery('#project-custom-91'));


}

function ValidateTimeHelper(name, sender) {
	EnableSaveP(true);
}

function FormatCurrencyHelper(sender) {
	var parsedValue = sender.val().replace("$", "");
	parsedValue = parsedValue.replace(',', "");
	var formattedValue = parsedValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	sender.val('$' + formattedValue);
}

function DeleteInternalMessages() {
	var parts = intMessagesCheckedRows.split(",");
	var i = 0;
	for (i = 0; i < parts.length; i++) {
		gIntMsgs.deleteRow(parts[i]);
	}
	PanteraScript.PanteraScriptService.DeleteInternalMessage(pjqSessionId, intMessagesCheckedRows, null, onScriptError);
	IntMessageToolbarRefresh();
}

function IntMessageToolbarRefresh(state) {
	intMessagesCheckedRows = gIntMsgs.getCheckedRows(0);

	if (intMessagesCheckedRows) {
		if (toolbarIntMessages.getListOptionSelected("view") != 'view_sent') {
			toolbarIntMessages.enableItem("mark_read");
			toolbarIntMessages.enableItem("mark_unread");
		}
		else {
			toolbarIntMessages.disableItem("mark_read");
			toolbarIntMessages.disableItem("mark_unread");
		}
		toolbarIntMessages.enableItem("delete");
	}
	else {
		toolbarIntMessages.disableItem("mark_read");
		toolbarIntMessages.disableItem("mark_unread");
		toolbarIntMessages.disableItem("delete");
	}
}

dhtmlXGridObject.prototype._in_header_master_checkbox_intm = function (a, b, c) {
	a.innerHTML = c[0] + "<input type='checkbox' />" + c[1];
	var d = this;
	a.getElementsByTagName("input")[0].onclick = function (a) {
		d._build_m_order();
		var c = d._m_order ? d._m_order[b] : b,
			g = this.checked ? 1 : 0;
		d.forEachRowA(function (a) {
			var b = this.cells(a, c);
			if (b.isCheckbox() && !b.isDisabled()) b.setValue(g), b.cell.wasChanged = !0;
			this.callEvent("onEditCell", [1, a, c, g]);
			this.callEvent("onCheckbox", [a, c, g])
		});
		IntMessageToolbarRefresh();
		(a || event).cancelBubble = !0;
	}
};

function eXcell_int_message(cell) {
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}; //read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	}; // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var template = "<a href='javascript:void(0)' onclick='return IntSubject(this)'>" + val + "</a>";
		this.setCValue(template, val);

		this.setAttribute('title', val);
	}
}

eXcell_int_message.prototype = new eXcell; // nest all other methods from base class

function grid_sort_intmsgs(a, b, order) {
	var optionA = a.substring(0, a.indexOf('</td>'));
	var optionB = b.substring(0, b.indexOf('</td>'));

	if (!optionA)
		optionA = a;

	if (!optionB)
		optionB = b;

	optionA = optionA.toLowerCase();
	optionB = optionB.toLowerCase();

	if (optionA == optionB)
		return 0;

	if (order == "asc")
		return optionA > optionB ? 1 : -1;
	else
		return optionA < optionB ? 1 : -1;

}

function lvdtc(sender) {
	var dtNow = new Date();
	var dtc = jQuery(sender).val();
	var dtCBD = new Date(dtc);
	addBusinessDays(dtCBD, -7);
	if (dtCBD.getTime() < dtNow.getTime())
		dtCBD.setTime(dtNow.getTime() + (1000 * 60 * 60 * 24));
	if (dtCBD.getDay() == 6)
		dtCBD.setTime(dtCBD.getTime() + (1000 * 60 * 60 * 24));
	if (dtCBD.getDay() == 0)
		dtCBD.setTime(dtCBD.getTime() + (1000 * 60 * 60 * 24));
	jQuery('#project-custom-168').val(jQuery.datepicker.formatDate('mm/dd/yy', dtCBD));
	var dtFUD = new Date(dtc);
	addBusinessDays(dtFUD, -1);
	if (dtFUD.getTime() < dtNow.getTime())
		dtFUD.setTime(dtNow.getTime() + (1000 * 60 * 60 * 24));
	if (dtFUD.getDay() == 6)
		dtFUD.setTime(dtFUD.getTime() + (1000 * 60 * 60 * 24));
	if (dtFUD.getDay() == 0)
		dtFUD.setTime(dtFUD.getTime() + (1000 * 60 * 60 * 24));
	jQuery('#project-custom-169').val(jQuery.datepicker.formatDate('mm/dd/yy', dtFUD));
	var dtBDD = new Date(dtc);
	addBusinessDays(dtBDD, -2);
	if (dtBDD.getTime() < dtNow.getTime())
		dtBDD.setTime(dtNow.getTime() + (1000 * 60 * 60 * 24));
	if (dtBDD.getDay() == 6)
		dtBDD.setTime(dtBDD.getTime() + (1000 * 60 * 60 * 24));
	if (dtBDD.getDay() == 0)
		dtBDD.setTime(dtBDD.getTime() + (1000 * 60 * 60 * 24));
	jQuery('#project-response-due').val(jQuery.datepicker.formatDate('mm/dd/yy', dtBDD));
	jQuery('#project-response-due-asap').prop('checked', false);
	ProjectResponseDueChanged();
	EnableSaveP();
}

function addBusinessDays(d, n) {
	var day = d.getDay();
	d.setDate(
		d.getDate() + n +
		(day === 6 ? 2 : +!day) +
		(Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
}

function DeleteContactPCF() {
	var i = 0;
	for (i = 0; i < projectContactFields.length; i++) {
		if (projectContactFields[i][0] == lastProjectCustomField) {
			var container = '#project-custom-' + lastProjectCustomField;
			var tb = projectContactFields[i][1];
			var grid = projectContactFields[i][2];
			var idToDelete = grid.getSelectedRowId();
			grid.clearSelection();
			grid.deleteRow(idToDelete);
			tb.disableItem("edit");
			tb.disableItem("delete");
			if (!jQuery(container).hasClass('pjq-multiple-contact-list')) {

				if (!settings.IsProjectHomeReadonly)
					tb.enableItem("add");
				var msg = 'No Contact Selected';

				jQuery('div.pjq-contact-grid', jQuery(container)).prepend("<div style='padding: 4px; background-color: white;'>" + msg.replace('"', '') + "</div>").css('height', '24px');
			}

			EnableSaveP();
			break;
		}
	}
}

function EditContactPCF() {
	var i = 0;
	for (i = 0; i < projectContactFields.length; i++) {
		if (projectContactFields[i][0] == lastProjectCustomField) {
			var grid = projectContactFields[i][2];
			var id = grid.getSelectedRowId();
			PanteraScript.PanteraScriptService.GetContactInfoAdmin(pjqSessionId, parseInt(id), EditContactPCFC, onScriptError);
			break;
		}
	}
}

function EditContactPCFC(response) {
	var contact = jQuery.parseJSON(response);
	jQuery("#dialog-edit-contact").html($("#PJQProjectWallAdmin-EditContact-TMPL").render(contact));
	if (typeof PJQProjectWallAdminEditContactInitialize == 'function')
		PJQProjectWallAdminEditContactInitialize(contact);

	var buttonList = {
		"Save Changes": function () {
			myInfoSave('pcf');
		}
	};

	if (settings.IsAddressBookRO)
		buttonList = {};

	var dlg = jQuery("#dialog-edit-contact").dialog({
		resizable: false,
		height: 600,
		width: 800,
		title: 'Contact Details',
		modal: true,
		draggable: false,
		buttons: buttonList

	});
	dlg.parent().appendTo($("Form[name='Form']"));
}

function EditContactPCFCC() {
	var i = 0;
	for (i = 0; i < projectContactFields.length; i++) {
		if (projectContactFields[i][0] == lastProjectCustomField) {
			var grid = projectContactFields[i][2];
			var id = grid.getSelectedRowId();
			PanteraScript.PanteraScriptService.GetContactInfo(pjqSessionId, 'c', id, EditContactPCFCCC, onScriptError);
		}
	}
}

function EditContactPCFCCC(response) {
	var contactInfo = jQuery.parseJSON(response);
	var i = 0;
	for (i = 0; i < projectContactFields.length; i++) {
		if (projectContactFields[i][0] == lastProjectCustomField) {
			var grid = projectContactFields[i][2];
			var tb = projectContactFields[i][1];
			grid.cells(grid.getSelectedRowId(), 0).setValue(contactInfo.ContactData);
			grid.cells(grid.getSelectedRowId(), 1).setValue(contactInfo.GroupList);
			tb.enableItem("edit");
			tb.enableItem("delete");
		}
	}
}

var lastEditorVal = "";

function initProjectNotesEditor(fieldValue) {
	dhtmlx.image_path = "/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxeditor/imgs/";
	notesEditor = new dhtmlXEditor("lv-pm-notes", 'dhx_web');
	notesEditor.init();

	notesEditor.setContent(cleanWordPaste(lastEditorVal));

	notesEditor.attachEvent("onAccess", function (eventName, e) {
		if (eventName == "keyup" || eventName == 'click') {
			if (e.ctrlKey && e.keyCode == 86) {
				setTimeout(function () {
					notesEditor.setContent(cleanWordPaste(notesEditor.getContent()));
					lastEditorVal = cleanWordPaste(notesEditor.getContent());
				}, 200);

			}
			if (eventName == 'keyup') {
				EnableSaveP();
				lastEditorVal = cleanWordPaste(notesEditor.getContent());
			}
		}
	});
	jQuery(notesEditor.edDoc.body).on('paste', function () {
		setTimeout(function () {
			notesEditor.setContent(cleanWordPaste(notesEditor.getContent()));
			lastEditorVal = cleanWordPaste(notesEditor.getContent());
			EnableSaveP();
		}, 400);
	});
	notesEditor.tb.hideItem('applyH1');
	notesEditor.tb.hideItem('applyH2');
	notesEditor.tb.hideItem('applyH3');
	notesEditor.tb.hideItem('applyH4');
	notesEditor.tb.hideItem('separ01');
	notesEditor.tb.hideItem('applySub');
	notesEditor.tb.hideItem('applySuper');
	notesEditor.tb.hideItem('separ04');
	notesEditor.tb.hideItem('increaseIndent');
	notesEditor.tb.hideItem('decreaseIndent');
	notesEditor.tb.hideItem('separ06');

	if (!pjqIsIE || pjqBrowserVersion > 8) {
		notesEditor.tb.addSeparator("font_sep", 27);
		var fontSizes = [
			['fs1', 'obj', '1', ''],
			['fs2', 'obj', '2', ''],
			['fs3', 'obj', '3', ''],
			['fs4', 'obj', '4', ''],
			['fs5', 'obj', '5', ''],
			['fs6', 'obj', '6', ''],
			['fs7', 'obj', '7', '']
		];
		notesEditor.tb.addButtonSelect("font_size", 28, "", fontSizes, 'textSizeIcon-01.png', null);

		var foregroundColors = [
			['fgff0000', 'obj', 'Red', ''],
			['fgff7f00', 'obj', 'Orange', ''],
			['fgffff00', 'obj', 'Yellow', ''],
			['fg00ff00', 'obj', 'Green', ''],
			['fg0000ff', 'obj', 'Blue', ''],
			['fg7f007f', 'obj', 'Purple', ''],
			['fgffffff', 'obj', 'White', ''],
			['fg000000', 'obj', 'Black', '']
		];
		notesEditor.tb.addButtonSelect("foreground_colors", 29, "", foregroundColors, 'textColorIcon-01-01.png', null);

		var backgroundColors = [
			['bgff0000', 'obj', 'Red', ''],
			['bgff7f00', 'obj', 'Orange', ''],
			['bgffff00', 'obj', 'Yellow', ''],
			['bg00ff00', 'obj', 'Green', ''],
			['bg0000ff', 'obj', 'Blue', ''],
			['bg7f007f', 'obj', 'Purple', ''],
			['bgffffff', 'obj', 'White', ''],
			['bg000000', 'obj', 'Black', '']
		];
		notesEditor.tb.addButtonSelect("background_colors", 30, "", backgroundColors, 'backgroundColorIcon-01.png', null);

		notesEditor.tb.addSeparator("tokens_sep", 31);

		notesEditor.tb.attachEvent("onClick", function (id) {
			if (id.indexOf('fs') !== -1) {
				notesEditor.runCommand('fontSize', id.substr(2));
				notesEditor.setContent(cleanWordPaste(notesEditor.getContent()));
			}
			else if (id.indexOf('fg') !== -1) {
				notesEditor.runCommand('foreColor', id.substr(2));
				notesEditor.setContent(cleanWordPaste(notesEditor.getContent()));
			}
			else if (id.indexOf('bg') !== -1) {
				notesEditor.runCommand('backColor', id.substr(2));
				notesEditor.setContent(cleanWordPaste(notesEditor.getContent()));
			}
			EnableSaveP();
		});
		notesEditor.attachEvent("onToolbarClick", function (name) {
			EnableSaveP();
		});
	}
}

function CountDigits(input) {
	var numDigits;
	numDigits = 0;
	if (input && input.length) {
		for (var i = 0; i < input.length; i++)
			if ("01234567890".indexOf(input.charAt(i)) >= 0)
				numDigits++;
	}

	return numDigits;
}